export default {

    CPF: '###.###.###-##',
    CNPJ: '##.###.###/####-##',
    CEP: '#####-###',
    CellphoneWithDDD: '(##) #####-####',
    LandlineOrCellphoneWithDDD: ['(##) #####-####', '(##) ####-####'],
    dateWithYear: ['##/##/####'],
    currency: { // Only with v-money
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
    }

}
